// NOTE: keep in sync with talentechFeedPlugin.ts.
export const splitMulti = (raw: string | undefined | null): string[] =>
  (raw ?? "")
    .split(/[;,]/)
    .map((s) => s.trim())
    .filter(Boolean);
